import ContentLoader from "@rio-cloud/rio-uikit/ContentLoader";
import TransactionSummarySkeleton from "./TransactionSummarySkeleton";
import {
  CELL_LABEL_HEIGHT,
  CELL_VALUE_HEIGHT,
  ITimelineSkeletonCell,
  TimelineSkeletonRow,
} from "./sharedSkeletonParts";

interface RecurrenceDetailsSkeletonProps {
  items?: number;
  summaryColumns?: number[];
}

const BADGE_HEIGHT = 22;
const STATUS_CELL_INDEX = 3;

const SUMMARY_COLUMNS = [2, 2, 2, 2, 2, 2];

const CELLS: ITimelineSkeletonCell[] = [
  { key: "recurrence-skeleton-cell-1", labelWidth: 80 },
  { key: "recurrence-skeleton-cell-2", labelWidth: 55 },
  { key: "recurrence-skeleton-cell-3", labelWidth: 60 },
  { key: "recurrence-skeleton-cell-4", labelWidth: 70 },
];
const CELL_VALUE_WIDTHS = [78, 72, 76, 70];

export default function RecurrenceDetailsSkeleton({
  items = 4,
  summaryColumns = SUMMARY_COLUMNS,
}: Readonly<RecurrenceDetailsSkeletonProps>) {
  return (
    <>
      <TransactionSummarySkeleton columns={summaryColumns} />

      <div className="margin-top-15">
        {Array.from({ length: items }, (_, index) => (
          <TimelineSkeletonRow
            key={index}
            isLast={index === items - 1}
            cells={CELLS}
            renderCell={(cell, cellIndex) => (
              <>
                <ContentLoader className="display-block" height={CELL_LABEL_HEIGHT} width={cell.labelWidth} />
                <div className="margin-top-5">
                  <ContentLoader
                    className="display-block"
                    height={cellIndex === STATUS_CELL_INDEX ? BADGE_HEIGHT : CELL_VALUE_HEIGHT}
                    width={CELL_VALUE_WIDTHS[(index + cellIndex) % CELL_VALUE_WIDTHS.length]}
                  />
                </div>
              </>
            )}
          />
        ))}
      </div>
    </>
  );
}
